let application = require('application')

let page404 = function (detail) {
  $('#container').css({
    opacity: '0.0'
  }).html(require('views/templates/404')(detail)).delay(50).animate({
    opacity: '1.0'
  }, 300)
}

let heartbeat = null

module.exports = Backbone.Router.extend({
  routes: {
    '': 'accueil',
    'accueil': 'accueil',
    'api/:apikey/:targetView': 'api',
    '!login/activate?*q': 'activate',
    '!:module/:submenu': 'default',
    '!:module?*queryString': 'defaultWithGET',
    '!:module': 'default',
    ':module': 'sansPrefixe'
  },
  initialize () {
    // /module/new : nouvel element
    // /module/1 : selection element
    // /module/update/1 : modifie l'element 1
    // /module/delete/1 : delete l'element 1

    this.route(/^!(\w+)\/(\d+)/, 'select')
    this.route(/^!(\w+)\/(\w+)\/(\d+)/, 'default')
  },
  session: null,
  activate (data) {
    application.ajax({
      url: '/login/activate',
      data,
      type: 'POST',
      complete: application.onComplete({
        success: (res) => {
          this.default('login', 'activate', res)
        },
        error: (error) => {
          this.default('login', 'activate', {errors: true, error})
        }
      })
    })
  },
  // Accueil
  select (view, id) {
    this.default(view, 'select', id)
  },

    // Ping pour conserver la connexion
  heartbeat (s) {
    if (!heartbeat) {
      heartbeat = setInterval(function () {
        $.getJSON('/heartbeat')
      }, 120000)
    }
  },

  // Accueil
  accueil () {
    this.default('accueil')
  },

  sansPrefixe (page) {
    window.location = '/#!' + page
  },
  // Est-on déjà identifié ?
  checkLogin (cb) {
    application.ajax({
      type: 'GET',
      url: '/login',
      complete: application.onComplete({
        success: (r) => {
          if (this.session == null) {
            this.session = r
          }
          cb(this.session)
        },
        error: () => cb()
      })
    })
  },

  // Déconnexion
  logout () {
    $.ajax({
      type: 'DELETE',
      url: '/login', // On envoi vers le checkLogin du jst server qui va vérifier le contenu de la session
      complete (response, status, xhr) {
        window.location = '/'
      }
    })
  },

  // and the function that parses the query string can be something like :
  parseQueryString (queryString) {
    let params = {}
    if (queryString) {
      _.each(
        _.map(decodeURI(queryString).split(/&/g), function (el, i) {
          let aux = el.split('=')
          let o = {}
          if (aux.length >= 1) {
            let val
            if (aux.length === 2) val = aux[1]
            o[aux[0]] = val
          }
          return o
        }),
        function (o) {
          _.extend(params, o)
        }
      )
    }
    return params
  },
  defaultWithGET (view, q) {
    this.default(view, null, null, this.parseQueryString(q))
  },
  default: function (view, event, id, paramsURL) {
    let that = this
    if (view) {
      // Puisqu'on change de page, on abandonne un ajax en cours...
      if (application.xhr_encours) {
        application.xhr_encours.abort()
      }

      this.checkLogin((session) => {
        let data = ''
        that.heartbeat() // Eviter timeout de la connexion
        // Identifié
        // On render le home
        if (session) application.homeView.setSession(session)
        if (paramsURL) application.homeView.setParamsURL(paramsURL)
        if (!application.homeView.rendered) {
          $('body').html(application.homeView.render().el)
        }

        let container = $('#container')
        let cb = function () { }

        if (event !== 'activate' && session && session.user && session.user.etat === 'attente') { // User en attente de confirmation
          container.html('<h1><i class="fa fa-cog fa-spin"></i> Chargement...</h1>')
          // application.loginView.setSession(session)
          // application.loginView.renderActivateScreen()
          this.default('login', 'activate')
        } else if (application.checkDroits(session, view, event)) {
          if (application[view + 'View']) {
            application[view + 'View'].setSession(session)
            application[view + 'View'].setParamsURL(paramsURL)

            let vue = application[view + 'View']

            // Si une vue de sous module existe
            if (application[view + '_' + event + 'View']) {
              vue = application[view + '_' + event + 'View']
            }
            // Si la vue est déjà rendue, alors on ne lance qu'afterRender en callback de fin de transition
            // On le fait aussi si le contenuer principal n'est pas présent
            if (!vue.rendered || !$('.' + view + '-page-content').length) {
              container.html('<h1><i class="fa fa-cog fa-spin"></i> Chargement...</h1>')
              data = vue.render(event, id).el
            } else {
              vue.afterRender(event, id)
            }
          } else {
            page404('Erreur de rendu de la vue : ' + view)
            return
          }
        } else {
          page404('Vous n\'avez pas le droit d\'accéder à cette page, si vous pensez que c\'est une erreur, merci de contacter l\'adminsitrateur du site.')
          return
        }

        if (data) {
          container.css({ opacity: '0.0' })
          .html(data)
          .delay(50)
          .queue((next) => {
            cb()
            next()
          })
          .animate({
            opacity: '1.0'
          }, 300)
        }
      })
    }
  }
})
